<!-- StatusBar.vue -->
<template>
  <div class="status-bar" :style="{backgroundColor:backGroundColor}">
    <div class="status-container">
      <v-icon :color="iconColor" :size="iconSize">{{ icon }}</v-icon>
      <p class="status-text">{{ statusText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusBar",
  props: {
    statusText: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: "rgba(0, 0, 0, 0.54)",
    },
    iconSize: {
      type: String,
      default: "14px",
    },
    backGroundColor:{
        type: String,
        required: true,
    }
  },
};
</script>

<style scoped>

.status-bar {
  display: flex;
  align-items: center;
  /* width: 70px; */
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(164, 162, 161, 0.4);

}

.status-container  {
  display: flex;
  padding: 6px 12px;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
 
}
.status-text {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
p{
    margin: 0;
}
</style>
